<div class="header-wrapper">
  <div class="header-icon">
    <ng-content select="ion-icon"></ng-content>
  </div>
  <div class="article-icon">
    <ng-content select="[article-icon]"></ng-content>
  </div>
  <div class="header-text">
    <ng-content></ng-content>
  </div>
  <div class="header-buttons">
    <ng-content select="itl-desktop-detail-view-header-button"></ng-content>
  </div>
</div>
